export default __webpack_public_path__ + "static/media/fld_bi_c.de733912.svg";